import React from 'react'
import { Outlet } from 'react-router-dom'
import { cn, createComponent } from '@lair-finance/util'
import { Footer } from '@/shared/ui/Footer'
import { Header } from '@/domains/header/ui/Header.tsx'

export type DefaultLayoutProps = React.HTMLAttributes<HTMLDivElement> & {
  containerClassName?: string
  contentClassName?: string
  noContainer?: boolean
  noFooter?: boolean
}

export const DefaultLayout = createComponent<HTMLDivElement, DefaultLayoutProps>(
  ({ children, containerClassName, contentClassName, noContainer, noFooter, ...props }, ref) => {
    return (
      <Container ref={ref} {...props}>
        <Header className={'sticky top-0 z-50 flex flex-col'} />
        <div className={cn('flex-1 flex flex-col', { container: !noContainer }, containerClassName)}>
          <Content className={contentClassName}>{children || <Outlet />}</Content>
        </div>
        {!noFooter && <Footer />}
      </Container>
    )
  },
  'DefaultLayout',
)

const Container = createComponent<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ children, className, ...props }, ref) => (
    <div className={cn('flex flex-col min-h-screen', className)} ref={ref} {...props}>
      {children}
    </div>
  ),
  'Container',
)

const Content = createComponent<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ children, className, ...props }, ref) => (
    <main className={cn('flex-1 flex flex-col w-full mx-auto pt-6 sm:pt-8 sm:pb-20', className)} ref={ref} {...props}>
      {children}
    </main>
  ),
  'Content',
)
